import { inject, Injectable, signal } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  isMobile = signal(false);

  private readonly breakpointObserver = inject(BreakpointObserver);

  constructor() {
    // 768px and down = mobile
    this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
      this.isMobile.set(result.matches);
    });
  }
}
